
import { Injectable, OnInit } from '@angular/core';
import { Http, Response, RequestOptions, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';
import { Subscription } from 'rxjs/Subscription';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/of';

import { Lagerplatz } from '../models/lagerplatz.model';
import { SettingsService } from '../services/settings.service';


@Injectable()
export class LagerplatzService implements OnInit{

    private controllerURL = 'LagerArtikel'; // Controllername in der API
    apiURL: string ;                        // URL to web API (API + Controller)
    
    lagerplatzStore: Lagerplatz[] = [];
    lagerplatzStore2: Lagerplatz[] = [];
    
    lagerplatzEin: Lagerplatz;

    body: string;
    query: string = "";
  
  
    constructor(private settings: SettingsService,
                private http: Http) {
  
      // create URL to web API
      this.apiURL = this.settings.getURL(this.controllerURL);
      console.log("apiURL = " + this.apiURL);
  
    }

    ngOnInit(): void {
  
    }

    //
    // Liest die Lagerplätze zu einem Artikel
    //
    getLagerplatzliste(artikelNr: string, top: string): Observable<Lagerplatz[]> {
      
      // Artikelstore leeren
      this.lagerplatzStore2 = [];
      
      const sucheUeber: string = "LSI_Artikelnummer";
      const vergleich: string = "eq";
     
      // Filterstring bilden
      const query: string= [
        `${sucheUeber}`,
        `${vergleich}`,
        `'${artikelNr}'`
      ].join(' '); 
            
      const params: string = [
        `$filter=${query}`,
        `$orderby=${sucheUeber}`,
        `$top=${top}`
      ].join('&'); 
      const queryUrl = `${this.apiURL}?${params}`;
      console.log("queryURL = " + queryUrl);
      
      const headers: Headers = this.settings.getHeader();
      const opts: RequestOptions = new RequestOptions();
      opts.headers = headers;
      opts.body = "";  
      
      this.http.get(queryUrl, opts)
        .map(response => response.json())
        .subscribe (
          artData => {
              this.lagerplatzStore = artData.value;
              this.lagerplatzStore.forEach(einPlatz => {
                  this.lagerplatzEin = einPlatz;
 //               console.log( "Lagerplatz: " + lagerplatzEin.LS_Lagerplatztext);
                  this.lagerplatzStore2.push(this.lagerplatzEin);
                  console.log(this.lagerplatzEin);
              })
              this.lagerplatzStore = this.lagerplatzStore2 ;
              return Observable.of(this.lagerplatzStore);
          },
          error => {
            this.handleError(error) ;
            return Observable.of(this.lagerplatzStore2); // Sollte leer sein
          }

   
        );

        return Observable.of(this.lagerplatzStore2); // Sollte leer sein
    }

    //
    // Liest alle Lagerplätze für alle gesuchten Artikel
    // Sortiert: Artikelnr, MHD, Platz
    getAlleLagerplatzliste(sucheUeber: string, vergleich: string, suchBegriff: string, 
                    top: string): Observable<Lagerplatz[]> {
      
      // Artikelstore leeren
      this.lagerplatzStore2 = [];
      
      // Filterstring bilden
      this.query = [
        `${sucheUeber}`,
        `${vergleich}`,
        `'${suchBegriff}'`
      ].join(' '); 
      // bei contains muss der Filter anders zusammengesetzt werden:
      // contains(Feldname,'suchbegriff')
      if ( vergleich === "contains") {
          this.query = [
            `contains(${sucheUeber},`,
            `'${suchBegriff}')`
            ].join(''); 
      }
           
      const params: string = [
        `$filter=${this.query}`,
        `$orderby=${sucheUeber}`,
        `$top=${top}`
      ].join('&'); 
      const queryUrl = `${this.apiURL}?${params}`;
      console.log("queryURL = " + queryUrl);
      
      const headers: Headers = this.settings.getHeader();
      const opts: RequestOptions = new RequestOptions();
      opts.headers = headers;
      opts.body = "";  
      
      this.http.get(queryUrl, opts)
        .map(response => response.json())
        .subscribe (
          artData => {
              this.lagerplatzStore = artData.value;
              this.lagerplatzStore.forEach(einPlatz => {
                  this.lagerplatzEin = einPlatz;
 //               console.log( "Lagerplatz: " + lagerplatzEin.LS_Lagerplatztext);
                  this.lagerplatzStore2.push(this.lagerplatzEin);
                  console.log(this.lagerplatzEin);
              })
              this.lagerplatzStore = this.lagerplatzStore2 ;
              return Observable.of(this.lagerplatzStore);
          },
          error => {
            this.handleError(error) ;
            return Observable.of(this.lagerplatzStore2); // Sollte leer sein
          }

   
        );

        return Observable.of(this.lagerplatzStore2); // Sollte leer sein
    }



  private handleError(error: any): Observable<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Observable.of(error.message || error);
    }

}


// WEBPACK FOOTER //
// D:/Crossplatform/swsLagerinfo/src/app/services/lagerplatz.service.ts